import { LoquixScrollAnchor } from './loquix-scroll-anchor.js';

if (!customElements.get('loquix-scroll-anchor')) {
  customElements.define('loquix-scroll-anchor', LoquixScrollAnchor);
}
